import React from "react";

const ButtonInline = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 6.75H21.625C21.8571 6.75 22.0796 6.82902 22.2437 6.96967C22.4078 7.11032 22.5 7.30109 22.5 7.5V16.5C22.5 16.6989 22.4078 16.8897 22.2437 17.0303C22.0796 17.171 21.8571 17.25 21.625 17.25H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17.25H2.375C2.14294 17.25 1.92038 17.171 1.75628 17.0303C1.59219 16.8897 1.5 16.6989 1.5 16.5V7.5C1.5 7.30109 1.59219 7.11032 1.75628 6.96967C1.92038 6.82902 2.14294 6.75 2.375 6.75H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.13271 13.8C5.83771 13.8 5.15771 12.94 5.15771 11.84V11.485C5.15771 10.4 5.84271 9.54 7.13771 9.54C8.29772 9.54 8.95271 10.255 9.01771 11.135L9.02271 11.315H8.29272L8.28772 11.09C8.25271 10.595 7.85772 10.165 7.13771 10.165C6.26771 10.165 5.88271 10.75 5.88271 11.445V11.895C5.88271 12.6 6.26771 13.175 7.13771 13.175C7.86771 13.175 8.25271 12.74 8.28772 12.245L8.29272 12.015H9.02271L9.01771 12.195C8.95271 13.085 8.30271 13.8 7.13271 13.8ZM9.60389 9.59H10.2789V13.75H9.60389V9.59ZM11.015 10.5H11.69V13.75H11.015V10.5ZM10.93 9.88C10.93 9.675 11.07 9.54 11.35 9.54C11.635 9.54 11.775 9.675 11.775 9.88C11.775 10.065 11.635 10.21 11.35 10.21C11.07 10.21 10.93 10.065 10.93 9.88ZM14.7162 11.7C14.6862 11.365 14.4412 11.035 13.8762 11.035C13.2312 11.035 12.9762 11.415 12.9762 11.985V12.28C12.9762 12.84 13.2312 13.215 13.8762 13.215C14.4812 13.215 14.6912 12.885 14.7162 12.55L14.7312 12.365H15.4212L15.4062 12.52C15.3512 13.2 14.8712 13.8 13.8662 13.8C12.8012 13.8 12.2762 13.185 12.2762 12.235V12.005C12.2762 11.065 12.8012 10.45 13.8662 10.45C14.8662 10.45 15.3612 11.045 15.4112 11.73L15.4212 11.89H14.7312L14.7162 11.7ZM15.9906 9.59H16.6656V11.82H16.9606L18.2306 10.5H19.0906L17.4706 12.12L19.0906 13.75H18.2306L16.9356 12.405H16.6656V13.75H15.9906V9.59Z"
      fill="currentColor"
    />
  </svg>
);

export default ButtonInline;
